module.exports = __webpack_public_path__ + "static/media/no-attachments.ee5d21e8.svg";